import appConst from '../constants/appConst'
import {configureApi} from '../../../../api/gerep/GerepAPI'

export default configureApi(appConst.gerepApi.baseUrl)
